import React, { useState, useEffect } from "react";
import styled from "styled-components";
import "./App.css";
import { colors, mediaQueries, fonts } from "./shared/config";
import bg_desktop from "./images/SundanceBG.svg";
import mountains from "./images/mountain.png"
import Card from './components/Card';
import { useWindowDimensions } from "./shared/hooks";
import divider from './images/EndingSpark.svg';

import Landing from "./components/Landing";
import Nav from "./components/Nav";

import LargeSubheader from './components/LargeSubheader'
import SmallSubheader from './components/SmallSubheader'
import PhotoWithCredits from './components/PhotoWithCredits'
import Header from './components/Header'

import fb from './images/socials/fb.svg'
import insta from './images/socials/insta.svg'
import twitter from './images/socials/twitter.svg'
import tiktok from './images/socials/tiktok.svg'
import email from './images/socials/email.svg'

const { bg, headings, subhead, body, accents } = colors;
const { mobile } = mediaQueries;
const { titles } = fonts;

const Content = styled("div")`
	background-image: url(${bg_desktop});
	background-size: 100%;
	/* background-color: #0C1D40; */
	z-index: -999;
	/* padding-bottom›››››››››: 150px; */

`;

const Paragraph = styled.div`
	font-family: ${titles};
	font-size: 18px;
	color: ${colors.text};
	margin: 0 100px;
	text-align: left;
	padding-bottom: 18px;
	${mediaQueries.mobile} {
		margin: 0 45px;
		font-size: 15px;
	}
`
const Shelf = styled.div`
	display: flex;
	flex-direction: row;
	gap: 100px;
	${mediaQueries.mobile} {
		margin: 0 45px;
		padding-top: 0;
	}
	/* padding-left: 17%; */
	align-content: center;
	justify-content: center;
  	height: 400px;
	position: relative;
	`
const ActsHeader = styled.div`
	background-color: ${colors.green};
	height: 85px;
	width: 100%;
	font-family: "Grandstander";
	font-size: 48px;
	font-weight: 700;
	color: ${colors.bg};
	line-height: 85px;
`


const DividerFlowers = styled.div`
	height: 70px;
	position: relative;
	img {
		height: 100%;
	}
	margin: 15px 0 15px 0;
	${mediaQueries.mobile} {
    height: 30px;
  }
`

const Mountainbg = styled.img`
	height:auto;
	width: 99vw;
	z-index: 999;
`

const Footer = styled.div`
	background-color: #0C1D40;
	height: 180px;
	color: white;
	padding: 80px 0 40px 0;
	h1 {
		margin: 0;
		font-family: 'Times New Roman', Times, serif;
	}
`

const Socials = styled.div`
	margin-top: 20px;
	img {
		margin: 0 20px;
	}
	p {
		margin-top: 80px;
		${mediaQueries.mobile} {
			margin-top: 50px;
		}
	}
`

function App() {
	const media = window.matchMedia('(max-width: 450px)');
  const [isMobile, setIsMobile] = useState(media.matches);
  media.addEventListener('change', () => {
  if (media.matches !== isMobile) {
      setIsMobile(media.matches);
  }
  });

	const { height, width } = useWindowDimensions();
	const [data, setData] = useState(null);
	
	useEffect(() => {
		fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/interactive.2022.sundance/")
		.then((res) => res.json())
		.then((res) => setData(res.data["article.aml"]));
	}, []);

	const shelfs = () => {
		if (data) {
			var temp = [];
			if (width > 700) {
				for (var i = 0; i < data['photo-frame-images'].length; i += 2) {
					temp.push(
						<Shelf>
							<Card articleLink={data['photo-frame-images'][i].article_link} imageURL={data['photo-frame-images'][i].image_link} 
							imageAlt={data['photo-frame-images'][i].article_title} title={data['photo-frame-images'][i].article_title} author={data['photo-frame-images'][i].byline} photoCredit={data['photo-frame-images'][i].photo_credits}
							/>
							<Card articleLink={data['photo-frame-images'][i+1].article_link} imageURL={data['photo-frame-images'][i+1].image_link} 
							imageAlt={data['photo-frame-images'][i+1].article_title} title={data['photo-frame-images'][i+1].article_title} author={data['photo-frame-images'][i+1].byline} photoCredit={data['photo-frame-images'][i+1].photo_credits}
							/>
						</Shelf>
					)
				}
			} else {
				for (var i = 0; i < data['photo-frame-images'].length; i++) {
					temp.push(
						<>
							<Card articleLink={data['photo-frame-images'][i].article_link} imageURL={data['photo-frame-images'][i].image_link} 
							imageAlt={data['photo-frame-images'][i].article_title} title={data['photo-frame-images'][i].article_title} author={data['photo-frame-images'][i].byline} photoCredit={data['photo-frame-images'][i].photo_credits}
							/>
						</>
					)
				}
			}
			return temp;
		} else {
			return null;
		}
		
	}
	
	return (
		<div className='App'>
			{data && 
			<>
				<Header />
      { !isMobile && <Landing src={data['landing_image']} creds={data['landing_credits']}/>}
      { isMobile && <Landing src={data['landing_image_mobile']} creds={data['landing_credits']}/>}
    	  <Nav/>
				<Content>
					
					<LargeSubheader title={data.title} id="intro"/>
					<SmallSubheader bylines={data.bylines}/>
					{data.content.map(block => {
						if (block.type === 'paragraph') {
							return (
								<Paragraph dangerouslySetInnerHTML={{__html: block.content}}/>
							)
						}
					})}
					<DividerFlowers>
						<img src={divider}/>
					</DividerFlowers>

					
					{data.content.map(block => {
						if (block.type === 'image') {
							return (
								<PhotoWithCredits link={block.image_link} credits={block.image_credits}/>
							)
						} 
					})}

					<DividerFlowers>
						<img src={divider}/>
					</DividerFlowers>
					{shelfs()}
					<DividerFlowers>
						<img src={divider}/>
					</DividerFlowers>
					<Mountainbg src={mountains}/>
				</Content>
				
				
			</>
			}
			<Footer>
				<h1>DAILY BRUIN</h1>
				<Socials>
					<a href="https://www.instagram.com/dailybruin" target="_blank"><img src={insta}/></a>
					<a href="https://www.facebook.com/dailybruin" target="_blank"><img src={fb}/></a>
					<a href="https://www.twitter.com/dailybruin" target="_blank"><img src={twitter}/></a>
					<a href="https://www.tiktok.com/@dailybruin" target="_blank"><img src={tiktok}/></a>
					<a href="http://eepurl.com/cFEiZX" target="_blank"><img src={email}/></a>
					<p>Built with Suzy’s ♥ in Kerckhoff 118 by Sunny Li and Mark Benliyan. Designed by Tang.</p>
				</Socials>
			</Footer>		
		</div>
	);
}
export default App;